import React from 'react';

import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Stack,
  Typography,
} from '@gogame/components';
import { useCurrencyFormat, usePercentFormat } from '@gogame/intl-ts';
import { ScreenLink } from '@gogame/screens';

import { FILTER_AGENCIES } from 'scenes/Influencers/InfluencersChannels/constants';
import { influencersChannelsLink } from 'scenes/Influencers/InfluencersChannels/navigation';
import { filtersSchema } from 'scenes/Influencers/InfluencersChannels/schemas';

export const MyTrackerAgencies = ({ agencies = [] }) => {
  const currencyFormatter = useCurrencyFormat();
  const percentFormatter = usePercentFormat();

  return (
    <TableContainer>
      <Table width={'100%'}>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell align={'right'} width={160}>
              Influencers Channels Allocated Budget
            </TableCell>

            <TableCell width={104} align={'right'}>
              Budget
            </TableCell>
            <TableCell>Influencers Channels </TableCell>
            <TableCell width={170}>Tracking Token</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {agencies.map(
            (
              { id, name, allocatedBudgetUsd, budgetUsd, myTrackerToken },
              i
            ) => (
              <TableRow key={`agency_${i}`}>
                <TableCell>{name}</TableCell>
                <TableCell align={'right'}>
                  <Stack direction={'column'} justifyContent={'flex-end'}>
                    <Typography variant={'inherit'}>
                      {currencyFormatter(allocatedBudgetUsd)}
                    </Typography>
                    <Typography color={'textSecondary'} variant={'caption'}>
                      {percentFormatter((allocatedBudgetUsd / budgetUsd) * 100)}
                    </Typography>
                  </Stack>
                </TableCell>

                <TableCell align={'right'}>
                  {currencyFormatter(budgetUsd)}
                </TableCell>
                <TableCell>
                  <ScreenLink
                    link={influencersChannelsLink}
                    params={{
                      filters: {
                        ...filtersSchema.default(),
                        [FILTER_AGENCIES]: [id],
                      },
                      ready: true,
                    }}
                  >
                    View channels
                  </ScreenLink>
                </TableCell>
                <TableCell>{myTrackerToken}</TableCell>
              </TableRow>
            )
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
